import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';

function ProgramaPeriodoModal({ show, onClose, onConfirm, title, isLoading }) {
  const [dataInicio, setDataInicio] = useState('');
  const [dataFim, setDataFim] = useState('');
  const [programaSelecionado, setProgramaSelecionado] = useState('');
  const [programas, setProgramas] = useState([]);
  const token = localStorage.getItem('token');
  const cnpj = localStorage.getItem('cnpj');

  useEffect(() => {
    if (show && cnpj) {
      // Carregar programas quando o modal é aberto
      axios
        .get(`${API_BASE_URL.PROGRAMA}/all`, {
          params: { cnpjAssociacao: cnpj },
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(result => {
          setProgramas(result.data);
        })
        .catch(error => {
          console.error('Erro ao obter programas:', error);
        });
    }
  }, [show, cnpj, token]);

  const handleConfirm = () => {
    if (dataInicio && dataFim && programaSelecionado && onConfirm) {
      // Validar se data início é menor que data fim
      if (new Date(dataInicio) > new Date(dataFim)) {
        alert('Data de início deve ser menor que data de fim');
        return;
      }

      // Parse do objeto programa
      const programaObj = JSON.parse(programaSelecionado);

      onConfirm({
        dataInicio,
        dataFim,
        programa: programaObj,
      });
    }
  };

  const handleClose = () => {
    setDataInicio('');
    setDataFim('');
    setProgramaSelecionado('');
    onClose();
  };

  // Função para obter data no formato YYYY-MM-DD
  const getToday = () => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  };

  // Função para obter primeiro dia do mês atual
  const getFirstDayOfMonth = () => {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    return firstDay.toISOString().split('T')[0];
  };

  // Função para definir período pré-definido
  const setPeriodoPredefinido = tipo => {
    const today = new Date();
    let inicio, fim;

    switch (tipo) {
      case 'mesAtual':
        inicio = new Date(today.getFullYear(), today.getMonth(), 1);
        fim = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        break;
      case 'mesPassado':
        inicio = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        fim = new Date(today.getFullYear(), today.getMonth(), 0);
        break;
      case 'anoAtual':
        inicio = new Date(today.getFullYear(), 0, 1);
        fim = new Date(today.getFullYear(), 11, 31);
        break;
      case 'ultimosTresMeses':
        inicio = new Date(today.getFullYear(), today.getMonth() - 2, 1);
        fim = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        break;
      case 'ultimosSeisMeses':
        inicio = new Date(today.getFullYear(), today.getMonth() - 5, 1);
        fim = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        break;
      default:
        return;
    }

    setDataInicio(inicio.toISOString().split('T')[0]);
    setDataFim(fim.toISOString().split('T')[0]);
  };

  if (!show) return null;

  return (
    <div
      className="modal show d-block small"
      tabIndex="-1"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">
          <div
            className="modal-header bg-primary text-white"
            style={{ height: '30px' }}
          >
            <h5 className="modal-title">
              <i className="bi bi-calendar3 me-2"></i>
              {title || 'Selecionar Programa e Período'}
            </h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={handleClose}
            ></button>
          </div>
          <div className="modal-body">
            <form>
              {/* Seleção de Programa */}
              <div className="row mb-3">
                <div className="col-12">
                  <label className="form-label fw-bold">
                    <i className="bi bi-diagram-3 me-1"></i>
                    Programa
                  </label>
                  <select
                    className="form-select"
                    value={programaSelecionado}
                    onChange={e => setProgramaSelecionado(e.target.value)}
                    required
                  >
                    <option value="">Selecione um programa...</option>
                    {programas.map(programa => (
                      <option
                        key={programa.id}
                        value={JSON.stringify(programa)}
                      >
                        {programa.descricao}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Períodos Pré-definidos */}
              <div className="row mb-3">
                <div className="col-12">
                  <label className="form-label fw-bold">
                    <i className="bi bi-lightning me-1"></i>
                    Períodos Rápidos
                  </label>
                  <div className="d-flex flex-wrap gap-2">
                    <button
                      type="button"
                      className="btn btn-outline-primary btn-sm"
                      onClick={() => setPeriodoPredefinido('mesAtual')}
                    >
                      Mês Atual
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-primary btn-sm"
                      onClick={() => setPeriodoPredefinido('mesPassado')}
                    >
                      Mês Passado
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-primary btn-sm"
                      onClick={() => setPeriodoPredefinido('ultimosTresMeses')}
                    >
                      Últimos 3 Meses
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-primary btn-sm"
                      onClick={() => setPeriodoPredefinido('ultimosSeisMeses')}
                    >
                      Últimos 6 Meses
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-primary btn-sm"
                      onClick={() => setPeriodoPredefinido('anoAtual')}
                    >
                      Ano Atual
                    </button>
                  </div>
                </div>
              </div>

              {/* Período Manual */}
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label fw-bold">
                    <i className="bi bi-calendar-date me-1"></i>
                    Data de Início
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    value={dataInicio}
                    onChange={e => setDataInicio(e.target.value)}
                    max={getToday()}
                    required
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label fw-bold">
                    <i className="bi bi-calendar-check me-1"></i>
                    Data de Fim
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    value={dataFim}
                    onChange={e => setDataFim(e.target.value)}
                    max={getToday()}
                    min={dataInicio}
                    required
                  />
                </div>
              </div>

              {dataInicio && dataFim && (
                <div className="alert alert-info">
                  <i className="bi bi-info-circle me-2"></i>
                  <strong>Período selecionado:</strong>{' '}
                  {new Date(dataInicio).toLocaleDateString('pt-BR')} até{' '}
                  {new Date(dataFim).toLocaleDateString('pt-BR')}
                  {programaSelecionado && (
                    <>
                      {' '}
                      para o programa{' '}
                      <strong>
                        {JSON.parse(programaSelecionado).descricao}
                      </strong>
                    </>
                  )}
                </div>
              )}
            </form>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary btn-sm"
              onClick={handleClose}
              disabled={isLoading}
            >
              <i className="bi bi-x-lg me-1"></i>
              Cancelar
            </button>
            <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={handleConfirm}
              disabled={
                !dataInicio || !dataFim || !programaSelecionado || isLoading
              }
            >
              {isLoading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                  ></span>
                  Gerando...
                </>
              ) : (
                <>
                  <i className="bi bi-check-lg me-1"></i>
                  Confirmar
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProgramaPeriodoModal;
